import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/** Section heading inside a card: 15/600 per the mockup. */
export const SectionTitle = ({
  children,
}: {
  children: string;
}): JSX.Element => (
  <HHTypography
    hhVariant="variant-bypass"
    variant="h6"
    component="h2"
    sx={{ fontSize: 15, fontWeight: 600 }}
  >
    {children}
  </HHTypography>
);

export interface StatRowProps {
  label: string;
  value: string | number;
  testId?: string;
}

/** Label on the left, value on the right, hairline between rows. */
export const StatRow = ({
  label,
  value,
  testId,
}: StatRowProps): JSX.Element => (
  <HHStack
    direction="row"
    justifyContent="space-between"
    alignItems="baseline"
    gap={4}
    paddingY={2.5}
    data-testid={testId}
    sx={(theme: Theme): SystemStyleObject<Theme> => ({
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-of-type': { borderBottom: 'none' },
    })}
  >
    <HHTypography
      hhVariant="variant-bypass"
      variant="body2"
      color="text.secondary"
    >
      {label}
    </HHTypography>
    <HHTypography
      hhVariant="variant-bypass"
      variant="body1"
      sx={{ fontWeight: 600, textAlign: 'right', wordBreak: 'break-all' }}
    >
      {value}
    </HHTypography>
  </HHStack>
);
